import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';
import { Router          } from '@angular/router';
import { RoutingPages    } from '../enums/routing/routing-pages.enum';
import { SessionManager  } from '../managers/session/session.manager';

@Injectable
({
  providedIn: 'root'
})

export class TokenError 
{
    constructor(
      private _notifier : NotifierManager ,
      private _router   : Router          ,
      private _session  : SessionManager  
    ) {}

    hasExpired () {
      this._notifier.show( Notifier.ERROR, NotifierMessage.TOKEN_HAS_EXPIRED)

      this._session.user().clear()

      this._router.navigate([RoutingPages.LANDING])
    }
}